import { lazy, Suspense, useEffect } from "react";
import Header from "../components/Header";
import Herosection from "../components/Herosection";
import { usePreferences } from "../PreferencesContext";

const About = lazy(() => import("../components/About"));
const Contact = lazy(() => import("../components/Contact"));
const Projects = lazy(() => import("../components/Projects"));
const Skills = lazy(() => import("../components/Skills"));
const ToastContainer = lazy(() => import("react-toastify").then((module) => ({
  default: module.ToastContainer,
})));

export default function Landing() {
  const { copy, theme } = usePreferences();

  useEffect(() => {
    document.title = copy.meta.title;
  }, [copy.meta.title]);

  return (
    <div className="min-h-dvh overflow-clip bg-[var(--page)] text-[var(--ink)] transition-colors duration-200">
      <a className="fixed top-3 left-4 z-[1000] -translate-y-[180%] rounded-full bg-[var(--blue-button)] px-4 py-3 text-sm font-semibold text-white no-underline transition-transform duration-200 ease-out focus:translate-y-0" href="#main-content">
        {copy.skip}
      </a>
      <Header />
      <main id="main-content">
        <Herosection />
        <Suspense fallback={null}>
          <About />
          <Skills />
          <Projects />
          <Contact />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          theme={theme}
          toastClassName="custom-toast"
          bodyClassName="custom-toast-body"
          progressClassName="custom-progress"
        />
      </Suspense>
    </div>
  );
}
